import * as actionTypes from './../Global_action.types';
import * as api from './../global_api_services/Unit.api';

export const uploadUnitMasterRequest = (fileData) => ({
  type: actionTypes.UPLOAD_UNIT_MASTER_REQUEST,
  payload: fileData,
});

export const uploadUnitMasterSuccess = (message) => ({
  type: actionTypes.UPLOAD_UNIT_MASTER_SUCCESS,
  payload: message,
});

export const uploadUnitMasterFailure = (error) => ({
  type: actionTypes.UPLOAD_UNIT_MASTER_FAILURE,
  payload: error,
});
export const uploadUnitMasterFile = (fileData,id) => {
  return async (dispatch) => {
    dispatch(uploadUnitMasterRequest(fileData));
    try {
      const response = await api.uploadUnitMaster(fileData,id);
      dispatch(uploadUnitMasterSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      dispatch(uploadUnitMasterFailure(error));
      const errorMessage = error?.response?.data?.error || error?.message || 'Upload failed';
      return { success: false, error: errorMessage };;
    }
  };
};

export const getUnitsRequest = () => ({
  type: actionTypes.GET_UNITS_REQUEST,
});

export const getUnitsSuccess = (units) => ({
  type: actionTypes.GET_UNITS_SUCCESS,
  payload: units,
});

export const getUnitsFailure = (error) => ({
  type: actionTypes.GET_UNITS_FAILURE,
  payload: error,
});

export const getUnits = (ClientID) => {
  return async (dispatch) => {
    dispatch(getUnitsRequest());
    try {
      const units = await api.fetchUnits(ClientID);
      dispatch(getUnitsSuccess(units));
      return { success: true, data: units };
    } catch (error) {
      dispatch(getUnitsFailure(error));
      return { success: false, message: error };
    }
  };
};
export const updateUnitRequest = (id, unitData) => ({
  type: actionTypes.UPDATE_UNIT_REQUEST,
  payload: { id, unitData },
});

export const updateUnitSuccess = (message) => ({
  type: actionTypes.UPDATE_UNIT_SUCCESS,
  payload: message,
});

export const updateUnitFailure = (error) => ({
  type: actionTypes.UPDATE_UNIT_FAILURE,
  payload: error,
});

export const updateUnitById = (id, unitData) => {
  return async (dispatch) => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    unitData.updated_by = user.user_name;

    dispatch(updateUnitRequest(id, unitData));
    try {
      const response = await api.updateUnit(id, unitData);
      dispatch(updateUnitSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(updateUnitFailure(error));
      return { success: false, message: error };
    }
  };
};


export const deleteUnitRequest = (id) => ({
  type: actionTypes.DELETE_UNIT_REQUEST,
  payload: id,
});

export const deleteUnitSuccess = (message) => ({
  type: actionTypes.DELETE_UNIT_SUCCESS,
  payload: message,
});

export const deleteUnitFailure = (error) => ({
  type: actionTypes.DELETE_UNIT_FAILURE,
  payload: error,
});

export const deleteUnitById = (id) => {
  return async (dispatch) => {
    dispatch(deleteUnitRequest(id));
    try {
      const response = await api.deleteUnit(id);
      dispatch(deleteUnitSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(deleteUnitFailure(error));
      return { success: false, message: error };
    }
  };
};
export const multiDaleteClientUnitsRequest = (ids) => ({
  type: actionTypes.MULTIDELETE_CLIENTUNITS_REQUEST,
  payload: ids,
});


export const multiDaleteClientUnitsSuccess = (message) => ({
  type: actionTypes.MULTIDELETE_CLIENTUNITS_SUCCESS,
  payload: message,
});

export const multiDaleteClientUnitsFailure = (error) => ({
  type: actionTypes.MULTIDELETE_CLIENTUNITS_FAILURE,
  payload: error,
});

export const multiDeleteClientUnitsFile = (ids) => {
  return async (dispatch) => {
    dispatch(multiDaleteClientUnitsRequest(ids));
    try {
      const response = await api.multiDeleteClientUnits(ids);
      // showSnackbar(response, 'success');
      dispatch(multiDaleteClientUnitsSuccess(response));
      return { success: true, message: response };
    } catch (error) {
      dispatch(multiDaleteClientUnitsFailure(error));
      return { success: false, message: error };
    }
  };
};

export const SingleDataUnitsRequest = (ClientDataInput) => ({
  type: actionTypes.SINGLEADD_UNIT_REQUEST,
  payload: ClientDataInput,
});

export const SingleDataUnitsSuccess = (user) => ({
  type: actionTypes.SINGLEADD_UNIT_SUCCESS,
  payload: user,
});

export const SingleDataUnitsFailure = (error) => ({
  type: actionTypes.SINGLEADD_UNIT_FAILURE,
  payload: error,
});


export const unitMasterSingleDataInput = (ClientDataInput) => {
  return async (dispatch) => {
    dispatch(SingleDataUnitsRequest(ClientDataInput));
    try {
      const response = await api.unitMasterDataInput(ClientDataInput);
      if (response.status === 200) {
        dispatch(SingleDataUnitsSuccess(response.data.user));
        return { success: true };
      } else {
        dispatch(SingleDataUnitsFailure(response.message || 'SingleData input failed'));
        return { success: false, message: response.message };
      }
    } catch (error) {      
      dispatch(SingleDataUnitsFailure(error || 'An error occurred'));
      return { success: false, message: error };
    }
  };
};



export const getAllUnitsRequest = () => ({
  type: actionTypes.GET_ALL_UNITS_REQUEST,
});

export const getAllUnitsSuccess = (units) => ({
  type: actionTypes.GET_ALL_UNITS_SUCCESS,
  payload: units,
});

export const getAllUnitsFailure = (error) => ({
  type: actionTypes.GET_ALL_UNITS_FAILURE,
  payload: error,
});

export const getAllUnits = () => {
  return async (dispatch) => {
    dispatch(getUnitsRequest());
    try {
      const units = await api.fetchAllUnits();
      dispatch(getUnitsSuccess(units));
      return { success: true, data: units };
    } catch (error) {
      dispatch(getUnitsFailure(error));
      return { success: false, message: error };
    }
  };
};


export const getUnitImportantBackupAction = (current_month, client_id) => {
  return async () => {
    try {
      const data = await api.getUnitImportantBackup(current_month);
      let rows = Array.isArray(data) ? data : [];
      if (client_id) {
        rows = rows.filter((r) => String(r.client_id) === String(client_id));
      }
      return { success: true, data: rows };
    } catch (error) {
      return { success: false, message: error };
    }
  };
};